<template>
  <div class="page">
    <div class="page__title">
      {{ getModuleConfig("exchange_records_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('exchange_records_page.form_desc')"
    ></div>
    <div  class="page__content" v-if="getModuleConfig('exchange_records_page.content')" v-html="getModuleConfig('exchange_records_page.content')"></div>
    <ExchangeRecords :event-code="eventCode"></ExchangeRecords>
  </div>
</template>

<script>
import pointMixin from "@/mixins/liff/point";
import ExchangeRecords from "@/components/Page/Liff/Point/ExchangeRecords";

export default {
  mixins: [pointMixin],
  components: {
    ExchangeRecords,
  },
  data() {
    return {
      eventCode: this.$route.query.event ?? null,
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/shared/components/_fields.scss';

.page { 
  background: var(--liff-content_bg_color);
  min-height: 100vh;
  
  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }
  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color);
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    b {
      color: var(--s-primary);
      font-weight: 600;
    }
  }
  &__content {
    margin: 10px 20px;
  }
}
</style>
